import { BlockLoading } from '../fetch-status/block-loading';
import { MarketStatusView } from './market-status';
import { UserEarings } from './user-earnings';
import { ViewResultFinalIcon, ViewResultSettlementIcon } from '@/client/assets';
import { useAppSettingStore } from '@/client/store/app-store';
import { cn } from '@/client/utils';
import { api } from '@/client/utils/api';
import { useMarketDetail } from '@/libs/react-sdk/api/use-market-detail';
import { MarketStatus } from '@/libs/sdk/api';
import { useTranslation } from 'react-i18next';

type MarketResultProps = {
  className?: string;
  marketAddress: string;
  uid: string;
};
export const MarketResult = ({ className, marketAddress, uid }: MarketResultProps) => {
  const { t } = useTranslation();
  const baseTokenAddress = useAppSettingStore(state => state.baseToken.address);
  const market = useMarketDetail(api, { baseTokenAddress, marketAddress });
  if (!market.data || market.isLoading) return <BlockLoading />;
  return (
    <div
      className={cn('border border-foreground/4 shadow-[0px_7px_15px_0px] shadow-foreground/10 p-4 rounded-3xl', className)}
    >
      <div className="pt-4 space-y-2">
        <div className="flex justify-center items-center">
          {market.data.marketStatus === MarketStatus.settlement && (
            <ViewResultSettlementIcon className="size-15 fill-beneficial" />
          )}
          {market.data.marketStatus === MarketStatus.closed && <ViewResultFinalIcon className="size-15 fill-beneficial" />}
        </div>
        <h3 className="text-center text-6 font-semibold leading-6 tracking-[-0.48px]">{t('results-out')}</h3>
      </div>
      <div className="space-y-2">
        <MarketStatusView marketAddress={marketAddress} className="mt-8 bg-foreground/4" />
        <UserEarings
          marketAddress={marketAddress}
          baseTokenAddress={market.data.baseTokenAddress}
          optionAddress={market.data.resultOptionAddress}
          marketStatus={market.data.marketStatus}
          isClaim={market.data.isClaim}
          optionsLen={market.data.optionList.length}
          uid={uid}
        />
      </div>
    </div>
  );
};
